import React, { Suspense } from "react";
import {
  Outlet,
  BrowserRouter as Router,
  Route,
  Routes as ROUTES,
} from "react-router-dom";
import Login from "../Auth/Login";
import PrivateRoute from "./PrivateRoute";
import Dashboard from "../Components/AdminDashboard/Dashboard";
import EditProfile from "../Components/EditProfile/EditProfile";
import PageNotFound from "../Components/PageNotFound/PageNotFound";
import DashboardTemplate from "../Components/AdminDashboard/DashboardTemplate";
import Loader from "../Components/Loader/Loader";

const Routes = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Router>
        <ROUTES>
          <Route path="/onboarding" element={<Login />} />
          <Route
            path="/onboarding/admin"
            element={
              <PrivateRoute>
                <DashboardTemplate>
                  <Outlet />
                </DashboardTemplate>
              </PrivateRoute>
            }
          >
            <Route path="" element={<Dashboard />} />
            <Route path="profile" element={<EditProfile />} />
          </Route>
          <Route path="*" element={<PageNotFound />} />
        </ROUTES>
      </Router>
    </Suspense>
  );
};

export default Routes;
